export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9848.c8584565.jpg";